import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: { marginBottom: "0.5rem" },
  title: { margin: 0, fontSize: "0.5rem", color: theme.palette.gray[600] },
  value: { lineHeight: "1.25rem", fontSize: "1rem" },
}));

/** Componente que exibe um título e o valor do dado
 * usado nas modals do processo de 'Envio para faturamento'.
 */
const MeasurementDetails = ({
  title,
  value,
}: {
  title: string;
  value: string;
}) => {
  const classes = useStyles();

  return (
    <Grid container item direction="column" className={classes.container}>
      <Typography
        variant="caption"
        className={classes.title}
        display="block"
        gutterBottom
      >
        {title}
      </Typography>
      <Typography variant="h6" className={classes.value} gutterBottom>
        {value}
      </Typography>
    </Grid>
  );
};

export default MeasurementDetails;
